// components/ProtectedRoute.js
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
    const { user } = useSelector(state => state.auth);

    if (!user) {
        // Se non c'è utente, reindirizza alla pagina di login
        return <Navigate to="/" />;
    }

    // Se l'utente è "scanner", reindirizza alla sua pagina dedicata
    if (user.username === 'scanner') {
        return <Navigate to="/scanner" />;
    }

    // Se l'utente è loggato e non è lo scanner, mostra il contenuto del dashboard
    return <Outlet />;
};

export default ProtectedRoute;